export enum UserType {
  BORROWER = 'borrower',
  INVESTOR = 'investor',
  SERVICE_PROVIDER = 'provider',
}

export enum UserTypeId {
  BORROWER = 1,
  INVESTOR = 2,
  SERVICE_PROVIDER = 3,
}

export enum PaymentMethod {
  NEW_CARD = 'new_card',
  SAVED_CARD = 'saved_card',
  WALLET = 'wallet',
}

export enum PaymentType {
  REPAYMENT = "REPAYMENT",
  DISBURSEMENT = "DISBURSEMENT",
}

export enum TransactionType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

export const VERIFY_EMAIL_REDIRECT_URL = `${process.env.REACT_APP_URL}/confirm-email`;

export const RESET_PASSWORD_REDIRECT_URL = `${process.env.REACT_APP_URL}/reset-password`;

export const TIME_OUT_DURATION = 4000;

export const USER_KEY = 'user';
